import { render, staticRenderFns } from "./log-transfer.vue?vue&type=template&id=09db1448&scoped=true&lang=pug&"
import script from "./log-transfer.vue?vue&type=script&lang=js&"
export * from "./log-transfer.vue?vue&type=script&lang=js&"
import style0 from "./log-transfer.vue?vue&type=style&index=0&id=09db1448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db1448",
  null
  
)

export default component.exports